/**
 * アプリケーション内で使用するルートパスの定数定義
 * 画面遷移時のパスをハードコードせず、この定数を使用する
 * 
 * ファイル配置: /src/config/routes.js
 */

// 基本的な画面パス
export const ROUTES = {
  // 認証関連
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  
  // 登録フロー
  TERMS: '/terms',
  AUTH: '/auth',
  REGISTER: '/register',
  CREDIT_CARD_INPUT: '/credit-card-input',
  REGISTRATION_COMPLETE: '/registration-complete',
  
  // メイン画面
  HOME: '/home',
  
  // 設定・編集画面
  MEMBER_EDIT: '/member-edit',
  CREDIT_CARD_EDIT: '/credit-card-edit',
  EMAIL_CHANGE: '/email-change',
  PASSWORD_CHANGE: '/password-change',
  PAYMENT_METHOD_SELECT: '/payment-method-select', 
  
  // その他
  ROOT: '/',
  NOT_FOUND: '*'
};

// パスにパラメータを含む場合のヘルパー関数
export const createRouteWithParams = {
  /**
   * 登録画面にemailパラメータを含めたパスを生成
   * @param {string} email - メールアドレス
   * @returns {string} パラメータ付きパス
   */
  registerWithEmail: (email) => `${ROUTES.REGISTER}?email=${encodeURIComponent(email)}`,
  
  /**
   * 他のパラメータ付きパスが必要な場合はここに追加
   */
};

// navigate時のオプション設定も定数化（必要に応じて）
export const NAVIGATION_OPTIONS = {
  REPLACE: { replace: true },
  WITH_SUCCESS_MESSAGE: (message) => ({ 
    state: { message } 
  })
};